export default {
      id: "library-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#library",
      toString: function () {
        return this.url;
      }
    }